import { render, staticRenderFns } from "./SpcmAnalyticsCounselorStudents.vue?vue&type=template&id=394b89a0"
import script from "./SpcmAnalyticsCounselorStudents.vue?vue&type=script&lang=js"
export * from "./SpcmAnalyticsCounselorStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports